import React, { useState, useEffect, useRef } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
// TODO Input con checkbox o con CopyToClipboard
// import { Checkbox } from '../checkbox/Checkbox'
// import { CopyToClipboard } from 'react-copy-to-clipboard'

import './InputContainer.scss'

/*
function usePrevious (value) {
  const ref = useRef()
  useEffect(() => {
    ref.current = value
  })
  return ref.current
}
*/

const InputContainer = ({
  value, type, name, maxLength, label, placeholder, isRequired, isDisabled,
  isInvalid, invalidMessage, containerClassName, className, inputClassName, onChange, notes, enablePressEnter, pressEnterCallback, forceInvalid,
  invalidClassName, hasInternalCheckbox, internalChechBoxValue, internalChechBoxLabel, buttonText, onClickInternalCheckbox, onClickButton, ...otherProps
}) => {
  const [isDirty, setIsDirty] = useState(false)

  const inputEl = useRef(null)

  const containerCamponentClassName = classNames(containerClassName, 'frontend-row frontend-m-bottom-0', {
    'c-input-container--invalid': isInvalid
  })

  const inputContainerClass = classNames(className, buttonText, {
    // 'col-xs-7  p-left-0 p-right-0': hasInternalCheckbox,
    // 'copy-to-clipboard-btn_container': buttonText
  })

  const inputClass = classNames(inputClassName, {
    'ng-invalid': isInvalid,
    'ng-dirty': isDirty,
    'input-con-parametro_input is-left': hasInternalCheckbox
  })

  const invalidNotesClassName = classNames('input_is-required_text', invalidClassName, {

  })

  function handleKeyUp (e) {
    setIsDirty(true)
  }

  useEffect(() => {
    if (value) {
      setIsDirty(true)
    }
  }, [value])

  function onKeyPress (event) {
    if (event) {
      if (enablePressEnter && event.key === 'Enter') {
        pressEnterCallback()
      }
    }
  }

  // function handelOnClickInternalCheckbox (e) {
  //   onClickInternalCheckbox(e)
  // }

  // const propsInternalChechBox = {
  //   className: 'm-left m-right truncate',
  //   name: 'searchFullText',
  //   label: internalChechBoxLabel,
  //   labelClassName: 'text-light label-simple',
  //   onChange: handelOnClickInternalCheckbox,
  //   checked: internalChechBoxValue,
  //   disabled: isDisabled
  // }

  return (
    <>
      <div className={containerCamponentClassName}>
        {label && (
          <div className='row-label'>
            <label>{label}</label> {isRequired && <strong>*</strong>}{' '}
          </div>
        )}
        <div className={inputContainerClass}>

          <input
            ref={inputEl}
            className={inputClass}
            type={type}
            name={name}
            maxLength={maxLength}
            placeholder={placeholder}
            value={value}
            disabled={isDisabled}
            onChange={onChange}
            onKeyUp={handleKeyUp}
            required={isRequired}
            onKeyPress={onKeyPress}

            {...otherProps}
          />

          {/* {buttonText &&
            <CopyToClipboard onCopy={onClickButton} text={value}>
              <button className='button-reset copy-to-clipboard-btn copy-to-clipboard-btn_input-text'>{buttonText}</button>
            </CopyToClipboard>} */}

        </div>

        {/* {hasInternalCheckbox &&
          <div className='col-xs-5 p-left-0 p-right-0 truncate'>

            <div className='input-con-parametro_parametro is-right text-center'>

              <Checkbox {...propsInternalChechBox} />
            </div>
          </div>} */}

        {notes && <div className='row m-bottom-0'><p className='input-note'>{notes}</p></div>}
        {(isDirty || forceInvalid) && isInvalid && invalidMessage && <div className='row m-bottom-0'><p className={invalidNotesClassName}>{invalidMessage}</p></div>}
      </div>
    </>
  )
}

InputContainer.defaultProps = {
  isRequired: false,
  isInvalid: false,
  isDisabled: false,
  type: 'text',
  maxLength: undefined,
  enablePressEnter: false,
  forceInvalid: false,
  invalidClassName: undefined,
  internalChechBoxValue: false
}

InputContainer.propTypes = {
  value: PropTypes.node,
  label: PropTypes.string,
  isRequired: PropTypes.bool,
  type: PropTypes.oneOf(['text', 'number']),
  placeholder: PropTypes.string,
  name: PropTypes.string,
  invalidMessage: PropTypes.string,
  isInvalid: PropTypes.bool,
  isDisabled: PropTypes.bool,
  className: PropTypes.string,
  onChange: PropTypes.func,
  pressEnterCallback: PropTypes.func,
  enablePressEnter: PropTypes.bool,
  forceInvalid: PropTypes.bool,
  invalidClassName: PropTypes.string,
  hasInternalCheckbox: PropTypes.bool,
  internalChechBoxLabel: PropTypes.string,
  onClickInternalCheckbox: PropTypes.func,
  containerCamponentClassName: PropTypes.string,
  internalChechBoxValue: PropTypes.bool,
  buttonText: PropTypes.string,
  onClickButton: PropTypes.func
}

export default InputContainer
